import { toast } from "sonner";
import { DealerRequestModel } from "../../domain/models/dealerModel";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function AddDealerToRoute(
  routes: RouteModel[],
  dealers: DealerRequestModel[],
  dropResult: DropResult,
): { routes: RouteModel[]; dealers: DealerRequestModel[] } {
  if (!dropResult.destination) {
    return {
      routes,
      dealers,
    };
  }

  // Get the draggable element and remove it from the existing place.
  const draggable = dropResult.draggableId;
  const dealerId = draggable.replace("new-dealer:", "");

  const dealer = dealers.find((d) => d.relation.id.toString() === dealerId);
  if (!dealer) {
    toast.error("Could not find dealer:" + dealerId + " to add");
    return {
      routes,
      dealers,
    };
  }

  // Get the destination element and add the draggable in the right place.
  const destination = dropResult.destination.droppableId;
  const routeId = destination.replace("route:", "");

  routes = routes.map((route) => {
    if (route.id == routeId) {
      const packingSlip = route.packingSlips.find(
        (slip) => slip.relation.id === dealer.relation.id,
      );

      if (packingSlip) {
        packingSlip.requests.push(...dealer.deliver_requests);
        packingSlip.pickup_amount =
          (packingSlip.pickup_amount ?? 0) + (dealer.pickup_amount ?? 0);
      } else {
        route.packingSlips.splice(dropResult.destination?.index ?? 0, 0, {
          id: "state:" + route.truck?.id + "-" + dealer.relation.id,
          requests: dealer.deliver_requests,
          relation: dealer.relation,
          status: "draft",
          date: route.date,
          pickup_amount: dealer.pickup_amount ?? 0,
        });
      }
    }
    return route;
  });

  dealers = dealers.filter((d) => `${d.relation.id}` !== `${dealerId}`);

  return {
    routes,
    dealers,
  };
}
